import React, { ReactNode } from 'react';

const getNearestDayNumber = (data, targetDay) => {
  // Convert the keys (day numbers) to an array of integers
  const days = Object.keys(data).map(Number);

  // Filter the days that are less than the target day
  const previousDays = days.filter((day) => day < targetDay);

  // If there are no previous days, return null
  if (previousDays.length === 0) {
    return null;
  }

  // Find the maximum (nearest) day number among the previous days
  const nearestPreviousDay = Math.max(...previousDays);

  return nearestPreviousDay;
};

export const getStepScheduledString = (
  relativeDays,
  stepNumber,
  dayAndSteps,
): ReactNode => {
  const keys = Object.keys(dayAndSteps);

  if ((stepNumber === 1 && keys?.length === 0) || relativeDays <= keys[0]) {
    return (
      <>This step will be scheduled as soon as the sequence is activated.</>
    );
  }

  // step schedule with existing day
  if (dayAndSteps[relativeDays]) {
    return (
      <>
        This step will be scheduled after{' '}
        <span className="font-semibold">Step {dayAndSteps[relativeDays]}</span>{' '}
        is done.
      </>
    );
  }

  return (
    <>
      This step will be scheduled{' '}
      <span className="font-semibold">
        {Number(relativeDays) - getNearestDayNumber(dayAndSteps, relativeDays)}{' '}
        days
      </span>{' '}
      after{' '}
      <span className="font-semibold">
        Step {dayAndSteps[getNearestDayNumber(dayAndSteps, relativeDays)]}
      </span>{' '}
      is done.
    </>
  );
};

export const getEditStepScheduledString = (
  relativeDays,
  stepNumber,
  dayAndSteps,
): ReactNode => {
  const keys = Object.keys(dayAndSteps);

  if (
    (stepNumber === 1 && keys?.length === 0) ||
    Number(relativeDays) < Number(keys[0])
  ) {
    return (
      <>This step will be scheduled as soon as the sequence is activated.</>
    );
  }

  // step schedule with existing day
  if (dayAndSteps[relativeDays]) {
    return (
      <>
        This step will be scheduled after{' '}
        <span className="font-semibold">Step {dayAndSteps[relativeDays]}</span>{' '}
        is done.
      </>
    );
  }

  return (
    <>
      This step will be scheduled{' '}
      <span className="font-semibold">
        {Number(relativeDays) - getNearestDayNumber(dayAndSteps, relativeDays)}{' '}
        days
      </span>{' '}
      after{' '}
      <span className="font-semibold">
        Step {dayAndSteps[getNearestDayNumber(dayAndSteps, relativeDays)]}
      </span>{' '}
      is done.
    </>
  );
};
